/**
 * Created by MiaoXiangzun on 2018-8-28.
 */
import React, {Component} from "react"
import {NavBar} from 'antd-mobile';
import {orderDetail} from "../../../service/orderService";
import moment from 'moment';

import './style.less';

export default class SearchOrderDetail extends Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            orderInfo: '',
            passengers: [],
        }
    }

    componentDidMount() {
        this.getOrderDetail(this.props.match.params.id);
    }

    getOrderDetail = (orderNo) => {
        const params = {
            orderNo: orderNo,
        };
        orderDetail(params)
            .then((res) => {
                if (res.data.code === '000000') {
                    this.setState({
                        orderInfo: res.data.data.info,
                        passengers: res.data.data.list,
                    });
                }
            }).catch(function (error) {
            console.log(error);
        })
    };

    getTimeArea = (day, time,timerInterval) => {
        if (time) {
            let dayTime = day + ' ' + time;
            let newTime = moment(dayTime).add(parseInt(timerInterval), "minutes").format("HH:mm");
            let timeArea = time.substr(0, 5) + '~' + newTime;
            return day + ' ' + (timerInterval == 0 ? time.substr(0, 5) : timeArea );
        }
    };


    render() {
        return (
            <div className={this.state.orderInfo.orderStatus === 0 ? "searchOrderdetail toBePaid" : "searchOrderdetail"}>
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >订单详情</NavBar>

                <div className="orderInfo">
                    <div className="orderNum">
                        <span>订单号</span>
                        <span>{this.state.orderInfo.orderNo}</span>
                    </div>
                    <div className="bottom">
                        <div>
                            <span>线路</span>
                            <div>{this.state.orderInfo.startName + '——' + this.state.orderInfo.endName}</div>
                        </div>
                        <div>
                            <span>乘车时间</span>
                            {/*<div>{this.getTimeArea(this.state.orderInfo.dayTime, this.state.orderInfo.time,this.state.orderInfo.timerInterval)}</div>*/}
                            <div>{this.state.orderInfo.dayTime +'  '+ this.state.orderInfo.time}</div>
                        </div>
                        <div>
                            <span>乘车人数</span>
                            <div>{this.state.orderInfo.number}</div>
                        </div>
                    </div>
                </div>

                <div className="payInfo">
                    <div className="top">
                        <div>
                            <div>订单金额</div>
                            <span>￥{this.state.orderInfo.totalPay}</span>
                        </div>
                        <div>
                            <div>抵扣金额</div>
                            <span>-￥{this.state.orderInfo === '' ? null : this.state.orderInfo.score.toFixed(2)}</span>
                        </div>
                    </div>
                    <div className="realPay">
                        <div>实际支付</div>
                        <span>￥{(this.state.orderInfo.totalPay - this.state.orderInfo.score).toFixed(2)}</span>
                    </div>
                </div>

                <div className="passengers">
                    {
                        this.state.passengers.map((res, i) => (
                            <div key={i} className="passenger">
                                <div className="top">
                                    <div>
                                        <i className="icon iconfont icon-tianjiaren"/>
                                        <span>{res.name}</span>
                                    </div>
                                    <span>{res.phone}</span>
                                </div>
                                <div className="middle">
                                    <div className="address">
                                        <div className="start">{res.startRideName}</div>
                                        <div className="end">{res.endRideName}</div>
                                    </div>
                                    <div className="seatInfo">
                                        <div>{res.seatNo}号座</div>
                                        <div>￥{res.price}</div>
                                    </div>
                                </div>


                            </div>
                        ))
                    }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/SearchOrderList/SearchOrderDetail/index.js